import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import type * as fhirTypes from "fhir/r4";

export interface AvailablePractitionersResponse {
  licensedClinicians: AvailablePractitionersResponse_Practitioner[];
  mas: AvailablePractitionersResponse_Practitioner[];
}

interface AvailablePractitionersResponse_Practitioner {
  practitioner: fhirTypes.Practitioner;
  isAlreadyAdded: boolean;
  notPedsQualified: boolean;
}

export const useAvailablePractitioners = (patientId: string) => {
  return useApi<AvailablePractitionersResponse>({
    queryOptions: {
      enabled: true,
      queryFn: async () => {
        const response =
          await axiosInstance.get<AvailablePractitionersResponse>(
            "/clinic/careteam/available-practitioners",
            {
              params: {
                patientId,
              },
            },
          );

        return response.data;
      },
      queryKey:
        QueryKeys.Patient.Chat.CareTeam.AVAILABLE_PRACITIONERS(patientId),
    },
  });
};
